export default __webpack_public_path__ + "static/media/yousign-logo.19e7b4fb.png";